export default {
  path: '/anomaly-types/:id',
  component: () =>
    import(
      '@/components/pages/AnomalyTypes/AnomalyType.vue'
    )
}
